<template>
    <div class="casetas">
        <h2 class="subheading grey--text">{{$t('vehicle_types')}}</h2>

        <v-container class="my-5">
            <v-layout align-center justify-center fill-height>
                <v-dialog v-model="dialog" persistent max-width="400px">
                    <template
                            v-slot:activator="{ on }">
                        <v-btn
                                color="primary"
                                dark v-on="on"
                                @click="update = false, clean_fields()">
                            + {{$t('add_vehicle_type')}}
                        </v-btn>
                    </template>
                    <v-form
                            @submit.prevent="update ?
                                        updateVehicleType(id_update) :
                                        createVehicleType()">
                        <v-card class="elevation-5">
                            <v-toolbar dark color="primary">
                                <v-toolbar-title>
                                    {{$t('vehicle_type')}}
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn
                                        class="align-self-end"
                                        color="red"
                                        icon
                                        @click="dialog = false">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-card-text>
                                <v-text-field
                                        v-model="nombre"
                                        v-if="dialog" autofocus
                                        prepend-icon="commute"
                                        name="nombre"
                                        :label="$t('nombre')"
                                        :error-messages="errores.name"
                                >
                                </v-text-field>
                                <v-checkbox
                                        v-model="activa"
                                        v-if="update" disable
                                        name="activa"
                                        :label="$t('Activo')"
                                        :error-messages="errores.is_active"
                                ></v-checkbox>
                                <v-alert
                                        :value=alerta
                                        type="warning"
                                        outline
                                        transition="scale-transition"
                                >
                                    Fallo con el Servidor
                                </v-alert>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn color="primary" @click="clear(), dialog = false">{{$t('cerrar')}}</v-btn>
                                <v-spacer/>
                                <v-btn v-if="update" :loading="loading" color="primary" type="submit">{{$t('modificar')}}</v-btn>
                                <v-btn v-else :loading="loading" color="primary" type="submit">{{$t('agregar')}}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-dialog>
            </v-layout>
            <v-layout class="my-4" align-center justify-center fill-height>
                <v-flex >
                    <v-card-title>
                        {{$t('vehicle_types')}}
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                :label="$t('Buscar')"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            :headers="headers"
                            :loading="loading_data_vehicleTypes"
                            :items="vehicleTypes"
                            :search="search"
                            :rows-per-page-text="$t('filas_por_pagina')"
                            :rows-per-page-items="[
                            {text: '5', value: 5},
                            {text: '10', value: 10},
                            {text: '25', value: 25},
                            {text: this.$t('todos'),
                            value: -1}]"
                            class="elevation-1"
                    >
                        <template v-slot:items="props">
                            <td class="justify-center layout px-0">
                                <v-icon
                                        medium
                                        class="mr-2"
                                        @click="fill_fields(props.item),
                                        update = true,
                                        dialog = true,
                                        id_update = props.item.id"
                                >
                                    edit
                                </v-icon>
                            </td>
                            <td>{{ props.item.name }}</td>
                            <td>{{ props.item.is_active ? "Si" : "No" }}</td>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                            </v-alert>
                        </template>
                        <template v-slot:pageText="props">
                            {{props.rowsPerPage}}
                            {{$t('Casetas')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    Vue.use(VeeValidate)
    import {mapState} from 'vuex'
    import { mapGetters } from 'vuex'

    export default {
        name: "vehicle_types",
        data: () => ({
            alerta: false,
            dialog: false,
            update: false,
            id_update: 0,
            nombre: '',
            activa: '',
            id_empresa: '', 
            errores: [],
            search: '',
            vehicleTypes: [],
            headers: [],
            loading_data_vehicleTypes: false,
            loading: false
        }),
        beforeUpdate(){
            this.headers = [
                {
                    text: this.$t('modificar'),
                    align: 'center',
                    sortable: false,
                    value: 'update'
                },
                // {
                //     text: 'ID',
                //     align: 'left',
                //     sortable: true,
                //     value: 'id'
                // },
                {
                    text: this.$t('nombre'),
                    align: 'left',
                    sortable: true,
                    value: 'name'
                },
                {
                    text: this.$t('Activo'),
                    align: 'left',
                    sortable: true,
                    value: 'is_active'
                }
            ]
        },
        computed: {
            ...mapState(['language']),
            ...mapGetters(['getProfile'])
        },
        created: function(){
            this.get_extra_data()
        },
        methods: {
            getVehicleTypes () {
                this.loading_data_vehicleTypes = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/Parking/vehicle-types/',
                    params: {
                        idEmpresa: this.id_empresa
                    },
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.vehicleTypes = response.data
                        this.loading_data_vehicleTypes = false
                    })
                    .catch(error => {
                        this.loading_data_vehicleTypes = false
                        console.log(error)
                    })
            },
            get_extra_data (){
                this.loading_data_vehicleTypes = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/auth/me',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.id_empresa = response.data.id_company
                        this.getVehicleTypes()
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            createVehicleType () {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.loading = true
                        this.errores = []
                        const config = {
                            method: 'post',
                            url: 'https://empresa-service.intrare.app/Parking/vehicle-types/',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept-Language': this.language ,
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: {
                                name: this.nombre,
                                idEmpresa: this.id_empresa
                            }
                        };
                        axios(config)
                            .then(ok => {
                                this.loading = false
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', this.$t('msg_vehicle_type_added'))
                                this.getVehicleTypes()
                                this.dialog = false
                                setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                this.loading = false
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores = error.response.data
                            })
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                });

            },
            updateVehicleType (id) {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.loading = true
                        this.errores = []
                        const config = {
                            method: 'put',
                            url: 'https://empresa-service.intrare.app/Parking/vehicle-types/' + id +'/',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept-Language': this.language ,
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: {
                                name: this.nombre,
                                is_active: this.activa,
                                idEmpresa: this.id_empresa
                            }
                        };
                        axios(config)
                            .then(ok => {
                                this.loading = false
                                this.getVehicleTypes()
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', this.$t('msg_vehicle_type_updated'))
                                this.dialog = false
                                setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                this.loading = false
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores = error.response.data
                            })
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                });
            },
            clear () {
                this.alerta = false
                this.errores = []
                this.$validator.reset()
                this.$store.commit('snackbar_activate_false')
            },
            fill_fields (item){
                this.nombre = item.name
                this.activa = item.is_active
            },
            clean_fields (){
                this.nombre = ''
                this.activa = ''
            }
        }
    }
</script>

<style scoped>

</style>
